import React, { useState, useRef } from 'react';
import { motion, useScroll, useMotionValueEvent, AnimatePresence } from 'framer-motion';
import { Menu, X, ChevronDown, Ticket } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/Button';
const plataformas = [{
  label: 'Ecosistema de Software',
  hash: 'ecosistema-software'
}, {
  label: 'Hardware y Equipamiento',
  hash: 'hardware-equipamiento'
}];
const soluciones = [{
  label: 'Eventos Masivos',
  hash: 'eventos-masivos'
}, {
  label: 'Clubes de Fútbol',
  hash: 'clubes-futbol'
}, {
  label: 'Asociaciones y Federaciones Deportivas',
  hash: 'asociaciones'
}, {
  label: 'Pequeños Eventos',
  hash: 'pequenos-eventos'
}, {
  label: 'Organizaciones sin Fines de Lucro',
  hash: 'sin-fines-de-lucro'
}, {
  label: 'Programas de Fidelización',
  hash: 'fidelizacion'
}, {
  label: 'Control de Accesos y Visitas',
  hash: 'control-accesos'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileSolucionesOpen, setIsMobileSolucionesOpen] = useState(false);
  const [isPlataformasDropdownOpen, setIsPlataformasDropdownOpen] = useState(false);
  const [isMobilePlataformasOpen, setIsMobilePlataformasOpen] = useState(false);
  const dropdownTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const plataformasDropdownTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const {
    scrollY
  } = useScroll();
  const location = useLocation();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  const handleDropdownEnter = () => {
    if (dropdownTimeout.current) clearTimeout(dropdownTimeout.current);
    setIsDropdownOpen(true);
  };
  const handleDropdownLeave = () => {
    dropdownTimeout.current = setTimeout(() => setIsDropdownOpen(false), 150);
  };
  const handlePlataformasEnter = () => {
    if (plataformasDropdownTimeout.current) clearTimeout(plataformasDropdownTimeout.current);
    setIsPlataformasDropdownOpen(true);
  };
  const handlePlataformasLeave = () => {
    plataformasDropdownTimeout.current = setTimeout(() => setIsPlataformasDropdownOpen(false), 150);
  };
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-slate-950/80 backdrop-blur-md py-4 border-b border-slate-800' : 'bg-transparent py-6'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-107">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-108">
        <Link to="/" className="flex items-center" data-id="element-109">
          <img src="https://cdn.magicpatterns.com/uploads/qfdEx4fYG73g9WHAKcydMH/logo_ticketmaestro_negativo.png" alt="TicketMaestro" className="h-8 md:h-10 w-auto" data-id="element-110" />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8" data-id="element-111">
          <Link to="/" className={`text-sm font-medium transition-colors ${location.pathname === '/' ? 'text-white' : 'text-slate-300 hover:text-white'}`} data-id="element-112">
            Inicio
          </Link>

          {/* Soluciones Dropdown */}
          <div className="relative" onMouseEnter={handleDropdownEnter} onMouseLeave={handleDropdownLeave} data-id="element-113">
            <Link to="/soluciones" className={`text-sm font-medium transition-colors flex items-center gap-1 ${location.pathname.startsWith('/soluciones') ? 'text-white' : 'text-slate-300 hover:text-white'}`} data-id="element-114">
              Soluciones
              <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`} data-id="element-115" />
            </Link>

            <AnimatePresence data-id="element-116">
              {isDropdownOpen && <motion.div initial={{
              opacity: 0,
              y: 8
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: 8
            }} transition={{
              duration: 0.15
            }} className="absolute top-full left-1/2 -translate-x-1/2 pt-3" data-id="element-117">
                  <div className="bg-slate-900 border border-slate-700/50 rounded-xl shadow-2xl shadow-black/40 py-2 min-w-[280px] backdrop-blur-xl" data-id="element-118">
                    {soluciones.map(item => <Link key={item.hash} to={`/soluciones#${item.hash}`} className="block px-4 py-2.5 text-sm text-slate-300 hover:text-white hover:bg-slate-800/60 transition-colors" onClick={() => setIsDropdownOpen(false)} data-id="element-119">
                        {item.label}
                      </Link>)}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>

          {/* Plataformas Dropdown */}
          <div className="relative" onMouseEnter={handlePlataformasEnter} onMouseLeave={handlePlataformasLeave} data-id="element-120">
            <Link to="/plataformas" className={`text-sm font-medium transition-colors flex items-center gap-1 ${location.pathname.startsWith('/plataformas') ? 'text-white' : 'text-slate-300 hover:text-white'}`} data-id="element-121">
              Plataformas y Equipamientos
              <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-200 ${isPlataformasDropdownOpen ? 'rotate-180' : ''}`} data-id="element-122" />
            </Link>

            <AnimatePresence data-id="element-123">
              {isPlataformasDropdownOpen && <motion.div initial={{
              opacity: 0,
              y: 8
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: 8
            }} transition={{
              duration: 0.15
            }} className="absolute top-full left-1/2 -translate-x-1/2 pt-3" data-id="element-124">
                  <div className="bg-slate-900 border border-slate-700/50 rounded-xl shadow-2xl shadow-black/40 py-2 min-w-[280px] backdrop-blur-xl" data-id="element-125">
                    {plataformas.map(item => <Link key={item.hash} to={`/plataformas#${item.hash}`} className="block px-4 py-2.5 text-sm text-slate-300 hover:text-white hover:bg-slate-800/60 transition-colors" onClick={() => setIsPlataformasDropdownOpen(false)} data-id="element-126">
                        {item.label}
                      </Link>)}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>

          <Link to="/sobre-nosotros" className={`text-sm font-medium transition-colors ${location.pathname === '/sobre-nosotros' ? 'text-white' : 'text-slate-300 hover:text-white'}`} data-id="element-127">
            Sobre Nosotros
          </Link>

          <Link to="/proximos-eventos" data-id="element-128">
            <Button variant="secondary" size="sm" className="whitespace-nowrap gap-1.5" data-id="element-129">
              <Ticket className="w-4 h-4 flex-shrink-0" data-id="element-130" />
              Compra Tus Entradas
            </Button>
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-131">
          {isMobileMenuOpen ? <X data-id="element-132" /> : <Menu data-id="element-133" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="md:hidden bg-slate-900 border-b border-slate-800" data-id="element-134">
          <div className="px-4 py-6 flex flex-col gap-4" data-id="element-135">
            <Link to="/" className={`text-base font-medium ${location.pathname === '/' ? 'text-white' : 'text-slate-300'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-136">
              Inicio
            </Link>

            {/* Mobile Soluciones Accordion */}
            <div data-id="element-137">
              <button className={`text-base font-medium flex items-center justify-between w-full ${location.pathname.startsWith('/soluciones') ? 'text-white' : 'text-slate-300'}`} onClick={() => setIsMobileSolucionesOpen(!isMobileSolucionesOpen)} data-id="element-138">
                Soluciones
                <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isMobileSolucionesOpen ? 'rotate-180' : ''}`} data-id="element-139" />
              </button>

              <AnimatePresence data-id="element-140">
                {isMobileSolucionesOpen && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.2
            }} className="overflow-hidden" data-id="element-141">
                    <div className="pl-4 pt-2 flex flex-col gap-2 border-l border-slate-700 ml-1 mt-2" data-id="element-142">
                      <Link to="/soluciones" className="text-sm text-slate-400 hover:text-white transition-colors py-1" onClick={() => setIsMobileMenuOpen(false)} data-id="element-143">
                        Ver todas
                      </Link>
                      {soluciones.map(item => <Link key={item.hash} to={`/soluciones#${item.hash}`} className="text-sm text-slate-400 hover:text-white transition-colors py-1" onClick={() => setIsMobileMenuOpen(false)} data-id="element-144">
                          {item.label}
                        </Link>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Mobile Plataformas Accordion */}
            <div data-id="element-145">
              <button className={`text-base font-medium flex items-center justify-between w-full ${location.pathname.startsWith('/plataformas') ? 'text-white' : 'text-slate-300'}`} onClick={() => setIsMobilePlataformasOpen(!isMobilePlataformasOpen)} data-id="element-146">
                Plataformas y Equipamientos
                <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isMobilePlataformasOpen ? 'rotate-180' : ''}`} data-id="element-147" />
              </button>

              <AnimatePresence data-id="element-148">
                {isMobilePlataformasOpen && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.2
            }} className="overflow-hidden" data-id="element-149">
                    <div className="pl-4 pt-2 flex flex-col gap-2 border-l border-slate-700 ml-1 mt-2" data-id="element-150">
                      <Link to="/plataformas" className="text-sm text-slate-400 hover:text-white transition-colors py-1" onClick={() => setIsMobileMenuOpen(false)} data-id="element-151">
                        Ver todas
                      </Link>
                      {plataformas.map(item => <Link key={item.hash} to={`/plataformas#${item.hash}`} className="text-sm text-slate-400 hover:text-white transition-colors py-1" onClick={() => setIsMobileMenuOpen(false)} data-id="element-152">
                          {item.label}
                        </Link>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            <Link to="/sobre-nosotros" className={`text-base font-medium ${location.pathname === '/sobre-nosotros' ? 'text-white' : 'text-slate-300'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-153">
              Sobre Nosotros
            </Link>

            <Link to="/proximos-eventos" onClick={() => setIsMobileMenuOpen(false)} data-id="element-154">
              <Button variant="secondary" className="w-full gap-1.5" data-id="element-155">
                <Ticket className="w-4 h-4 flex-shrink-0" data-id="element-156" />
                Compra Tus Entradas
              </Button>
            </Link>
          </div>
        </motion.div>}
    </motion.nav>;
}